(function () {
    angular
        .module('app')
        .controller('WorkgroupController', WorkgroupController);

    // Define controller dependencies.
    WorkgroupController.$inject = ['$rootScope', '$scope', 'CRUDFactory', 'DataListFactory'];

    /**
     * Controller for 'main' view of 'master.workgroup' state.
     *
     * @param $rootScope
     * @param $scope
     * @param CRUDFactory
     * @param DataListFactory
     * @constructor
     */
    function WorkgroupController($rootScope, $scope, CRUDFactory, DataListFactory) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            var resource = 'workgroup';

            $rootScope.global.pageTitle = 'Master Workgroup';

            $scope.shared.printDisabled = true;
            $scope.shared.editor.template = 'components/master/workgroup/workgroup-editor.view.html';
            $scope.shared.editor.focusElement = '#workgroup--application-code';
            $scope.shared.reader.template = 'components/master/workgroup/workgroup-reader.view.html';

            DataListFactory.reset();
            DataListFactory.resource = resource;
            DataListFactory.gridOptions.columnDefs = angular.copy($rootScope.global.columnDefs.common);
            DataListFactory.gridOptions.columnDefs.splice.apply(DataListFactory.gridOptions.columnDefs,
                [1, 0].concat($rootScope.global.columnDefs[resource]));

            DataListFactory.advancedSearchFactory.reset();
            DataListFactory.advancedSearchFactory.resource = resource;
            angular.forEach($rootScope.global.searchResourceFields[resource], function (relation) {
                var resourceField = {
                    relation: relation.relation,
                    fields  : angular.copy($rootScope.global.resourceFields.common)
                }
                resourceField.fields.splice.apply(resourceField.fields,
                    [1, 0].concat($rootScope.global.resourceFields[relation.resource]));
                DataListFactory.advancedSearchFactory.resourceFields.push(resourceField);
            });

            CRUDFactory.resource = resource;
        }

        activate();
    }
})();
